export const SESSION_EXPIRED = 'session-expired';

export default SESSION_EXPIRED;
